
function connectCategories(maps) {
  maps.get('productMap').forEach((product)=>
    product.categories.forEach((category, i)=> {
      let category_exists_in_store = maps.get('categoryMap').get(category.id || category);
      if (category_exists_in_store) product.categories[i] = category_exists_in_store     
    }) 
  );
  maps.get('categoryMap').forEach((category) =>
    category.products.forEach((product, i)=>
      category.products[i] = maps.get('productMap').get(product.id || product) || product));

}

function connectAuthors(maps) {
  maps.get('productMap').forEach((product)=>
    product.authors.forEach((author, i)=>
      product.authors[i] = maps.get('authorMap').get(author.id || author)));
  maps.get('authorMap').forEach((author) =>
    author.products.filter(p=>maps.get('productMap').get(p.id || p)).forEach((product, i)=>
      author.products[i] = maps.get('productMap').get(product.id || product) || product));
}

function connectGenres(maps) {
  maps.get('productMap').forEach((product)=>
    product.genres.forEach((genre, i)=> {
      let genre_exists_in_store = maps.get('genreMap').get(genre.id || genre);
      if (genre_exists_in_store) product.genres[i] = genre_exists_in_store     
    }) 
  );
  maps.get('genreMap').forEach((genre) =>
    genre.products.filter(p=>maps.get('productMap').get(p.id || p)).forEach((product, i)=>
      genre.products[i] = maps.get('productMap').get(product.id || product) || product));
}

function connectPromos(maps) {
  maps.get('productMap').forEach((product)=>
    product.promos.forEach((promo, i)=> {
      let promo_exists_in_store = maps.get('promoMap').get(promo.id || promo);
      if (promo_exists_in_store) product.promos[i] = promo_exists_in_store     
    }) 
  );
  maps.get('promoMap').forEach((promo) =>
    promo.products.filter(p=>maps.get('productMap').get(p.id || p)).forEach((product, i)=>
      promo.products[i] = maps.get('productMap').get(product.id || product) || product));
}

function connectPublishers(maps) {
  maps.get('productMap').forEach((product)=>
    product.publisher =
      product.publisher ? maps.get('publisherMap').get(product.publisher.id || product.publisher) : null);
  maps.get('publisherMap').forEach((publisher) =>
    publisher.products.forEach((product, i)=>
      publisher.products[i] = maps.get('productMap').get(product.id || product) || product));
}

function connectImprints(maps) {
  maps.get('productMap').forEach((product)=>
    product.imprint =
      product.imprint ? maps.get('imprintMap').get(product.imprint.id || product.imprint) : null);
  maps.get('imprintMap').forEach((imprint) =>
    imprint.products.forEach((product, i)=>
      imprint.products[i] = maps.get('productMap').get(product.id || product) || product));
}

function connectFeatured(maps) {
  maps.get('featureMap').forEach((value, key)=>{
    maps.get('featureMap').set(key, { ...maps.get('productMap').get(value.id || value), format: value.format })
  });
}

export function assemble(newKVs, oldMaps) {
  oldMaps = oldMaps || new Map([
    ['productMap', new Map()],
    ['categoryMap', new Map()],
    ['authorMap', new Map()],
    ['genreMap', new Map()],
    ['promoMap', new Map()],
    ['publisherMap', new Map()],
    ['imprintMap', new Map()],
    ['featureMap', new Map()]
  ]);
  newKVs.forEach(([key, map])=> map.forEach(([k,v]) => oldMaps.get(key).set(k, v)));
  connectCategories(oldMaps);
  connectAuthors(oldMaps);
  connectGenres(oldMaps);
  connectPromos(oldMaps);
  connectPublishers(oldMaps);
  connectImprints(oldMaps);
  connectFeatured(oldMaps);
  return oldMaps;
}


// WEBPACK FOOTER //
// ./src/shared/product.js